/* Poseidon Equipment: shop page helpers (loaded by sections/pzs-styles.liquid). Small and dependency free. */
(function () {
  'use strict';

  /* Signature Build gallery: scroll-snap track (swipe on phones), arrows, thumbnails, counter, zoom dialog. */
  function initGallery(root) {
    if (root.dataset.pzsReady) return;
    root.dataset.pzsReady = '1';
    var track = root.querySelector('[data-pzs-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pzs-thumb]'));
    var cur = root.querySelector('[data-pzs-cur]');
    var prev = root.querySelector('[data-pzs-prev]');
    var next = root.querySelector('[data-pzs-next]');
    var dialog = root.querySelector('[data-pzs-dialog]');
    var zoomImg = root.querySelector('[data-pzs-zoom-img]');
    var index = 0;

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      if (i === index) return;
      index = i;
      if (cur) cur.textContent = String(i + 1);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      var t = thumbs[i];
      if (t && t.parentElement) {
        var p = t.parentElement;
        var left = t.offsetLeft - (p.clientWidth - t.clientWidth) / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    if (prev) prev.disabled = true;

    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth || 1;
        mark(Math.round(track.scrollLeft / w));
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-pzs-thumb'), 10) || 0); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });

    if (dialog && zoomImg && typeof dialog.showModal === 'function') {
      slides.forEach(function (s) {
        var src = s.getAttribute('data-pzs-zoom');
        if (!src) return;
        s.addEventListener('click', function () {
          zoomImg.src = src;
          var img = s.querySelector('img');
          if (img) { zoomImg.width = img.naturalWidth || img.width; zoomImg.height = img.naturalHeight || img.height; }
          dialog.showModal();
        });
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target === zoomImg || e.target.closest('[data-pzs-close]')) dialog.close();
      });
    }
  }

  /* Category rail: on phones, bring the current category chip into view (no animation). */
  function initRail() {
    Array.prototype.forEach.call(document.querySelectorAll('.pzs-rail'), function (rail) {
      function edge() { rail.classList.toggle('is-end', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4); }
      rail.addEventListener('scroll', edge, { passive: true });
      var on = rail.querySelector('.is-on');
      if (on && rail.scrollWidth > rail.clientWidth) {
        var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        var target = on.offsetLeft - pad;
        if (on.offsetLeft + on.offsetWidth > rail.clientWidth - 48) rail.scrollLeft = Math.max(0, target);
      }
      edge();
    });
  }

  /* Added-to-cart confirmation. Horizon adds to cart without leaving the page; this shows a small panel
     with the item and a View cart button (the cart drawer stays closed so the page never squeezes). */
  var toast, toastTimer;
  function esc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function showToast(title, count) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pz pzs-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
      toast.addEventListener('click', function (e) { if (e.target.closest('[data-pzs-toast-close]')) hideToast(); });
    }
    var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
    toast.innerHTML =
      '<span class="pzs-toast-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' +
      '<div class="pzs-toast-txt"><b>Added to your cart</b>' + (title ? '<span>' + esc(title) + '</span>' : '') + '</div>' +
      '<a class="pz-btn pz-btn-primary pz-btn-sm" href="' + cartUrl + '">View cart' + (count ? ' (' + count + ')' : '') + '</a>' +
      '<button class="pzs-toast-x" type="button" data-pzs-toast-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 7000);
  }
  function hideToast() { if (toast) toast.classList.remove('is-on'); }
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var action = e.action || (e.detail && e.detail.action);
    if (action && action !== 'add') return;
    if (document.body.dataset.template === 'cart' || location.pathname.replace(/\/$/, '').slice(-5) === '/cart') return;
    var titleEl = document.querySelector('.pzs-phead-title, .quick-add-modal .product-title, .pzs-rhero-title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var p = e.promise || (e.detail && e.detail.promise);
    if (p && p.then) {
      p.then(function (res) {
        var n = res && res.cart && res.cart.totalQuantity;
        showToast(title, n);
      }).catch(function () {});
    } else {
      showToast(title, 0);
    }
  });

  /* Signature Build: a slim order bar on phones and tablets once the hero buttons scroll away. */
  function initRigBar() {
    var bar = document.querySelector('[data-pzs-rbar]');
    var buy = document.querySelector('.pzs-rhero-buy');
    if (!bar || !buy || bar.dataset.pzsReady || !('IntersectionObserver' in window)) return;
    bar.dataset.pzsReady = '1';
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      var btn = bar.querySelector('button');
      if (btn) btn.tabIndex = past ? 0 : -1;
    });
    io.observe(buy);
  }

  /* R10: description intro "Read more" (blocks/pzs-product-lede). The rest of the first paragraph is in the page,
     hidden; the button shows it in place and can hide it again. Delegated, so quick-add modals work too. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pzs-more-btn]') : null;
    if (!btn) return;
    var rest = document.getElementById(btn.getAttribute('aria-controls'));
    if (!rest) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    if (!btn.getAttribute('data-more')) btn.setAttribute('data-more', btn.textContent);
    rest.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? (btn.getAttribute('data-less') || 'Show less') : btn.getAttribute('data-more');
  });

  /* R10: the machine fit box ("Sized for 8 GPM machines", blocks/pzs-product-specs) follows the selected option.
     Liquid writes every variant's box (from the poseidon.fits_gpm metafields) into a JSON blob next to it; when the
     option changes, the box is set from that blob. A variant with no fit hides the box: no data, no claim. */
  function setFit(scope, vid) {
    var box = scope.querySelector('[data-pzs-fit]');
    var blob = scope.querySelector('[data-pzs-fit-data]');
    if (!box || !blob) return;
    var data;
    try { data = JSON.parse(blob.textContent || '{}'); } catch (err) { return; }
    var d = vid ? data[String(vid)] : null;
    var t = d && d.t ? d.t : '';
    var url = d && d.u ? d.u : '';
    box.hidden = !t;
    Array.prototype.forEach.call(box.querySelectorAll('[data-pzs-fit-text]'), function (el) { el.textContent = t; });
    var link = box.querySelector('[data-pzs-fit-link]');
    var plain = box.querySelector('[data-pzs-fit-static]');
    if (link) { link.hidden = !url; if (url) link.setAttribute('href', url); }
    if (plain) plain.hidden = !!url;
  }
  function currentVariantId(scope) {
    var input = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) return input.value;
    try { return new URL(location.href).searchParams.get('variant'); } catch (err) { return null; }
  }
  document.addEventListener('shopify:product:select', function (e) {
    var t = e.target;
    var scope = t && t.closest ? t.closest('.shopify-section, dialog') : null;
    if (!scope || !scope.querySelector('[data-pzs-fit-data]')) return;
    var settled = false;
    var p = e.promise || (e.detail && e.detail.promise);
    if (p && p.then) {
      p.then(function (r) {
        var v = r && r.detail ? r.detail.resource : null;
        settled = true;
        setFit(scope, v && v.id ? v.id : null);
      }).catch(function () {});
    }
    /* belt and braces: if the event carries no promise, read the chosen variant once the form has updated */
    setTimeout(function () { if (!settled) setFit(scope, currentVariantId(scope)); }, 1200);
  });

  function init() {
    initRigBar();
    Array.prototype.forEach.call(document.querySelectorAll('[data-pzs-gal]'), initGallery);
    initRail();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
